module.exports = __webpack_public_path__ + "img/der_01_fx.b59c856e.png";